export const PAGE_PATH = {
  TOP_PAGE: '/',
  LOGIN_PAGE: '/login',
} as const;
